import { gql } from "@apollo/client";


// TODO: Hvor meget skal med fra den gamle?
export const FEED_CURVE_FRAGMENT = gql`
  fragment FeedCurveFields on FeedCurve {
    feedCurveId
    name
    feedLimit
    passFeed
    stimuli
    info(domain: $domain) @include(if: $ifFeedCurveInfo) {
      active
      default
      deleted
    }
    times(domain: $domain) @include(if: $ifSpreading) {
      timeId
      time
    }
    components(domain: $domain) @skip(if: $ifFeedCurveBaseInfoOnly) {
      gramPerMinute
      componentId
      feedCurveComponentId
      name
      ds
    }
    milestones(domain: $domain) {
      milestoneId
      feedCurveMilestoneId
      name
      milestoneIndex
      feedPlan(domain: $domain) @include(if: $ifSpreading) {
        lastMilestoneDay
        plan {
          day
          amount
          feedPlanEntryId
          timeId
        }
      }
      feedDays(domain: $domain) @skip(if: $ifFeedCurveBaseInfoOnly) {
        day
        dayId
        dayComponents {
          componentId
          dayComponentId
          amount
        }
      }
    }
  }
`

// TODO: Hvor meget skal med fra den gamle?
export const GET_FEED_CURVES = gql`
  query FeedCurves($domain: String!, $input: PanelBasicQueryInfoInput!, $ifFeedCurveBaseInfoOnly: Boolean!, $ifFeedCurveInfo: Boolean!, 
  $ifSpreading: Boolean!) {
    feedCurve {
      info(domain: $domain, input: $input) {
        ...FeedCurveFields
      }
    }
  }
  ${FEED_CURVE_FRAGMENT}
`;



export interface FeedCurvesResponse {
  feedCurve: {
    info: FeedCurve[]
  }
}

export interface FeedCurve {
  feedCurveId: number,
  name: string,
  feedLimit: number,
  passFeed: number,
  stimuli: number;
  info?: FeedCurveInfo,
  times?: FeedCurveTime[],
  components?: FeedCurveComponent[],
  milestones?: FeedCurveMilestone[],
}

interface FeedCurveInfo {
  active: boolean,
  default: boolean,
  deleted: boolean,
}

export interface FeedCurveTime {
  timeId: number,
  time: number,
}

export interface FeedCurveComponent {
  gramPerMinute: number,
  limit: number,
  componentId: number,
  feedCurveComponentId: number,
  name: string,
  ds: number,
}
export interface FeedCurveMilestone {
  milestoneId: number,
  feedCurveMilestoneId: number,
  name: string,
  milestoneIndex: number,
  feedPlan?: FeedPlan,
  feedDays: FeedDay[],
}

interface FeedPlan {
  lastMilestoneDay: number,
  plan: FeedPlanEntry[],  
}

export interface FeedPlanEntry {
  day: number,
  amount: number,
  feedPlanEntryId: number,
  timeId: number,
}

interface FeedDay {
  day: number,
  dayId: number,
  dayComponents: DayComponent[]
}

export interface DayComponent {
  componentId: number,
  dayComponentId: number,
  amount: number,
}